import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import {
  Button,
  ButtonDirective,
  ButtonIcon,
  ButtonLabel,
} from 'primeng/button';
import { AutoFocus } from 'primeng/autofocus';
import { PrimeIcons } from 'primeng/api';
import { Message } from 'primeng/message';
import { UserBehaviorMonitoringService } from '@tokenbox/services';

@Component({
  selector: 'lib-coming-soon-dialog',
  templateUrl: './coming-soon-dialog.component.html',
  styleUrls: ['./coming-soon-dialog.component.scss'],
  imports: [
    Button,
    ButtonDirective,
    AutoFocus,
    ButtonIcon,
    ButtonLabel,
    Message,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComingSoonDialogComponent implements OnInit {
  data = inject(DynamicDialogConfig).data as {
    featureId: string;
    text: string;
  };

  protected readonly PrimeIcons = PrimeIcons;
  private dialogRef = inject(DynamicDialogRef);
  private monitoringService = inject(UserBehaviorMonitoringService);

  subscribed = signal(false);

  ngOnInit() {
    this.monitoringService.capture('Feature Intent Viewed', {
      feature_id: this.data.featureId,
    });
  }

  close() {
    this.dialogRef.close();
  }

  protected subscribeToUpdate() {
    this.monitoringService.capture('Feature Requested', {
      feature_id: this.data.featureId,
    });
    this.subscribed.set(true);
  }
}
